<template>
  <div
    class="sticky-receipt w-full shadow-lg focus:outline-none fixed top-0 right-0 lg:hidden left-0 border px-4 pt-2 pb-4 border-neutral-200"
    :class="{
      'pb-4': fillerWidth > 0,
      'pb-2': fillerWidth <= 0,
      'opacity-0 pointer-events-none': !isVisible
    }"
    :disabled="isDisabled"
    :aria-label="$t('Accessibilty.AriaLabels.ScrollBackToCart')"
    @click="$emit('click')"
  >
    <div v-for="(product, i) in products" :key="`${product.name}-${i}`">
      <div class="flex items-center relative">
        <div :class="['super-box', product.comboImage ? 'mr-half' : 'mr-rem']">
          <transition name="bounce" mode="out-in">
            <OImage
              :key="JSON.stringify(product.image)"
              v-bind="product.image"
              :alt="$t('Accessibilty.AltTags.ProductImage')"
            />
          </transition>

          <OSvg v-if="hasComboProduct" svg="new-big-plus-icon" class="plus-icon fill-black text-yellow-400" />
        </div>
        <div v-if="product.comboImage" class="super-box mr-rem">
          <transition name="bounce" mode="out-in">
            <OImage
              :key="JSON.stringify(product.comboImage)"
              v-bind="product.comboImage"
              :alt="$t('Accessibilty.AltTags.ProductImage')"
            />
          </transition>
        </div>
        <div class="flex-1 text-left flex flex-row items-center">
          <span class="font-display font-extrabold text-neutral-800 text-sm">
            {{ product.name }}
          </span>
          <p v-if="product.dealText" class="ml-2 font-display font-extrabold text-xs text-white bg-orange-500 rounded-sm px-2" v-text="product.dealText" />
        </div>
        <div class="flex flex-row items-center">
          <p class="font-display font-normal line-through pr-3 text-xs" v-text="product.price" />
          <span class="font-display font-extrabold text-sm uppercase text-green-400" v-text="product.text" />
        </div>
      </div>
      <div v-if="i < products.length - 1" class="pr-4 py-1">
        <hr class="border-neutral-200 divider-border">
      </div>
    </div>
    <div class="meter-bar-container absolute right-0">
      <div class="meter-bar overflow-hidden mt-3">
        <div class="meter-bar-filler" :style="{ width: `${fillerWidth}%` }" />
      </div>
    </div>
  </div>
</template>

<script>
import OImage from '@/components/OImage'
import OSvg from '@/components/OSvg'

export default {
  name: 'OnePagerStickyReceipt',
  components: {
    OImage,
    OSvg
  },
  props: {
    fillerWidth: {
      type: Number,
      default: 0
    },
    products: {
      type: Array,
      default: () => []
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasComboProduct () {
      return this.products.some(product => product.comboImage)
    }
  }
}
</script>

<style scoped lang="postcss">
.sticky-receipt {
  transition: opacity 0.3s ease-in-out;
  background-color: #F1F2F7;

  .super-box {
    @apply border border-neutral-200 flex justify-center items-center p-1 bg-white;
    min-width: 3rem;
    max-width: 3rem;
    min-height: 3rem;
    max-height: 3rem;
    border-radius: .12rem;

    >>> img {
      max-width: 2rem !important;
    }
  }

  .plus-icon {
    @apply w-4 absolute;
    left: 24.7px;
  }

  .divider-border {
    @apply ml-auto;
    max-width: 80%;
  }

  .meter-bar {
    @apply relative;
    border-radius: 1rem;
    height: 4px;

    &-container {
      bottom: -2px;
      left: -2px;
    }

    &-filler {
      @apply absolute left-0 h-full bg-orange-500;
      border-top-right-radius: 9999px;
      border-bottom-right-radius: 9999px;
      width: 0%;
      -webkit-transition: width 1s ease-in-out;
      -moz-transition: width 1s ease-in-out;
      -o-transition: width 1s ease-in-out;
      transition: width 1s ease-in-out;
    }
  }
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.4);
  }
  100% {
    transform: scale(1);
  }
}
</style>
